module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"tariffExpired":"Тариф закончился","renewTariff":"Продлить тариф"}}')
  delete Component.options._Ctor
}
